import React, { useEffect, useState } from "react";
import { Sun, Moon } from "lucide-react";

// Tiny theme toggle that switches between light and dark modes by toggling
// the Tailwind 'dark' class on the documentElement. Persists in localStorage.
export function ThemeToggle() {
  const [theme, setTheme] = useState("light");

  useEffect(() => {
    const root = document.documentElement;
    // Determine current theme: 1) persisted preference, 2) match system preference, 3) current DOM
    const persisted = typeof localStorage !== "undefined" ? localStorage.getItem("theme") : null;
    if (persisted) {
      // If user previously selected a theme, honor it
      const current = persisted;
      if (current === "dark") root.classList.add("dark"); else root.classList.remove("dark");
      setTheme(current);
      return;
    }
    // No persisted preference: honor system preference
    const sysDark = typeof window !== 'undefined' && window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
    const current = sysDark ? "dark" : "light";
    if (current === "dark") root.classList.add("dark"); else root.classList.remove("dark");
    setTheme(current);
  }, []);

  const toggle = () => {
    const root = document.documentElement;
    const next = root.classList.contains("dark") ? "light" : "dark";
    if (next === "dark") {
      root.classList.add("dark");
    } else {
      root.classList.remove("dark");
    }
    localStorage.setItem("theme", next);
    setTheme(next);
  };

  return (
    <button
      aria-label="Toggle color theme"
      onClick={toggle}
      className="p-2 rounded-full bg-background border border-border hover:bg-slate-100 inline-flex items-center justify-center"
      title="Toggle theme"
    >
      {theme === "dark" ? (
        <Sun className="w-4 h-4" />
      ) : (
        <Moon className="w-4 h-4" />
      )}
    </button>
  );
}
